import React, { type FC } from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';

import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import MagicSearchImage from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/software/components/magic-search/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Empty: FC<Record<any, any>> = () => {
	const { formatMessage } = useIntl();

	return (
		<Container>
			<Box xcss={ImageWrapperStyles}>
				<MagicSearchImage alt="" />
			</Box>
			<P>{formatMessage(messages.empty)}</P>
		</Container>
	);
};

const ImageWrapperStyles = xcss({
	height: '72px',
	width: '72px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	marginTop: token('space.100'),
	marginRight: token('space.150'),
	marginBottom: token('space.100'),
	marginLeft: token('space.150'),
	/* Same as a DropdownItem */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
	lineHeight: `${gridSize * 2}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const P = styled.p({
	whiteSpace: 'initial',
	textAlign: 'center',
});
